<template>
  <div class="try-for-free__container">
    <div class="try-for-free__content">
      <div class="try-for-free__content-text">
        <Heading class="try-for-free__content-feature-name" size="h6" color="orange">
          {{ featureName }}
        </Heading>
        <Box mb="6">
          <Heading size="h1">
            {{ title }}
          </Heading>
        </Box>
        <Box mb="6">
          <Paragraph size="large">
            {{ description }}
          </Paragraph>
        </Box>
        <RssUiButton
          class="try-for-free__content-button lp-button"
          :href="$locatedLink('/auth/sign-up/', dashboardAppUrl)"
          :blank="false"
          rainbow
        >
          {{ $t('pages.ssr_features.pages.common.try_for_free.button') }}
        </RssUiButton>
      </div>
      <img
        class="try-for-free__content-image"
        :src="imagePath"
        :srcset="`${imagePath.replace(/(\.png)$/, '@2x$1')} 2x`"
        :alt="imageAlt"
      >
    </div>
  </div>
</template>

<script>
import { config } from '@/config'

import Box from '@/components/common/Box/Box'
import Heading from '@/components/common/Heading/Heading'
import Paragraph from '@/components/common/Paragraph/Paragraph'

export default {
  components: {
    Box,
    Heading,
    Paragraph
  },

  props: {
    featureName: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imagePath: {
      type: String,
      required: true
    },
    imageAlt: {
      type: String,
      default: null
    }
  },

  computed: {
    dashboardAppUrl () {
      return config.dashboardAppUrl
    }
  }
}
</script>

<style lang="scss" scoped>
.try-for-free {
  &__container {
    padding-left: $gap;
    @include display-less(desktop) {
      padding: 0;
    }
  }

  &__content {
    margin: 0 auto;
    max-width: 1120px;
    width: 100%;
    display: flex;
    gap: $gap * 2;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    @include display-less(desktop) {
      flex-direction: column;
    }

    &-text {
      @include display-less(desktop) {
        margin: 0 $gap;
      }
    }

    &-feature-name {
      margin-bottom: $gap  * 0.25;

      @include display-less(desktop) {
        margin-top: $gap * 2.5;
      }
    }

    &-button {
      width: fit-content;
      font-weight: bold;

      @include display-less(desktop) {
        width: 100%;
      }
    }

    &-image {
      max-width: 605px;

      @include display-less(hd) {
        max-width: 530px;
      }

      @include display-less(desktop) {
        max-width: 605px;
        width: 100%;
      }
    }
  }
}
</style>
